import React from 'react';
import { Link } from 'react-router-dom';
import { CookieManagerTriggerNavLink } from './CookieContext';

function Footer() {
  return (
    <footer style={{
      width: '100%',
      background: 'transparent',
      color: '#ccc',
      textAlign: 'center',
      padding: '24px 0 12px 0',
      fontSize: '1rem'
    }}>
      <div style={{marginBottom: '8px'}}>
        <Link to="/privacy" style={{color: '#42bbdd', margin: '0 12px'}}>Privacy Policy</Link>
        <Link to="/terms" style={{color: '#42bbdd', margin: '0 12px'}}>Terms of Use</Link>
        <Link to="/contact" style={{color: '#42bbdd', margin: '0 12px'}}>Contact</Link>
        <span style={{margin: '0 12px'}}><CookieManagerTriggerNavLink /></span>
      </div>
      <div style={{fontSize: '0.9rem'}}>
        &copy; {new Date().getFullYear()} Held Solutions LLC
      </div>
    </footer>
  );
}

export default Footer;
